import React, { FC } from "react";
import { Stack } from "@mui/material";

import { NAMED_COLORS } from "@src/utils";

interface Props {
  size: "default" | "narrow" | "full";
  extendBottom?: boolean;
  backgroundColor?: string;
  background?: string;
  children: JSX.Element | string | undefined;
  bottomPaddingOverride?: any;
}

const ContentGroup: FC<Props> = ({
  size = "default",
  backgroundColor = "white",
  background = "",
  extendBottom = false,
  children,
  bottomPaddingOverride = {},
}) => {
  const hexColor =
    backgroundColor in NAMED_COLORS
      ? NAMED_COLORS[backgroundColor]
      : NAMED_COLORS["white"];

  const sizeMap_paddingBottom = {
    default: "1280px",
    narrow: "748px",
    full: "100%",
  };

  const bottomPadding = {
    xs: "24px",
    md: "40px",
  };

  if (extendBottom) {
    bottomPadding.xs = "50px";
    bottomPadding.md = "200px";
  }

  if (bottomPaddingOverride && bottomPaddingOverride?.xs) {
    bottomPadding.xs = bottomPaddingOverride?.xs;
  }

  if (bottomPaddingOverride && bottomPaddingOverride?.md) {
    bottomPadding.md = bottomPaddingOverride?.md;
  }

  return (
    <Stack
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: sizeMap_paddingBottom[size],
        margin: "0 auto",
        paddingBottom: bottomPadding,
        background: background,
        backgroundColor: hexColor,
        borderRadius: {
          xs: "0",
          sm: size === "narrow" ? "8px" : "15px",
          md: size === "narrow" ? "15px" : "30px",
        },
        zIndex: "2",
      }}
    >
      {children}
    </Stack>
  );
};

export default ContentGroup;
